import React, { useState } from "react";
import { Button } from "antd";
import { DownloadOutlined, DeleteOutlined, FileOutlined } from "@ant-design/icons";
import useAbortController from "../../Common/hooks/useAbortController";
import { handleRcaDocumentDownload } from "./utils";
import "./RcaDocuments.css";

const RcaDocuments = ({
  s3Keys = [],
  emptyText = "No documents yet",
  removableS3Keys = [],
  onRemove = null,
}) => {
  const [downloadKey, setDownloadKey] = useState(null);
  const { setNewAbortController } = useAbortController();
  const removableKeySet = new Set(removableS3Keys || []);

  if (!Array.isArray(s3Keys) || s3Keys.length === 0) {
    return <div className="RcaDocuments__Empty">{emptyText}</div>;
  }

  const onDownload = async (s3Key) => {
    setDownloadKey(s3Key);
    const abortController = setNewAbortController();
    await handleRcaDocumentDownload(s3Key, abortController.signal);
    setDownloadKey(null);
  };

  return (
    <ul className="RcaDocuments__List">
      {s3Keys.map((s3Key) => {
        const fileName = s3Key.split("/").pop() || s3Key;
        const isDownloading = downloadKey === s3Key;
        const canRemove = typeof onRemove === "function" && removableKeySet.has(s3Key);
        return (
          <li key={s3Key} className="RcaDocuments__Item">
            <span className="RcaDocuments__FileName">
              <FileOutlined />
              {fileName}
            </span>
            <span className="RcaDocuments__Actions">
              <Button
                type="link"
                size="small"
                icon={<DownloadOutlined />}
                loading={isDownloading}
                onClick={() => onDownload(s3Key)}
              >
                Download
              </Button>
              {canRemove && (
                <Button
                  type="link"
                  size="small"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => onRemove(s3Key)}
                >
                  Delete
                </Button>
              )}
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default RcaDocuments;
